export function logout() {
    const domain = process.env.REACT_APP_COGNITO_DOMAIN;
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const logoutRedirect = encodeURIComponent(process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI);

    // Clear local tokens
    localStorage.removeItem("idToken");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    const logoutUrl = `https://${domain}/logout?client_id=${clientId}&logout_uri=${logoutRedirect}`;

    // Perform logout
    window.location.href = logoutUrl;
}
